import { render, staticRenderFns } from "./PowerBiVisual.vue?vue&type=template&id=40a41208"
import script from "./PowerBiVisual.vue?vue&type=script&lang=js"
export * from "./PowerBiVisual.vue?vue&type=script&lang=js"
import style0 from "./PowerBiVisual.vue?vue&type=style&index=0&id=40a41208&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports